import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { getMultiPolygonBounds, multiPolygonWithHolesToGeoJSON } from "@nova/calculate-geospatial"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import store from "integrations/redux/store"
import { createExternalStore } from "@nova/toolkit-pure-hooks"
import { CachedNotam } from "../../types"
import { SupportedRegions } from "@nova/constants"

const MAX_TFR_ENTRY_COUNT = 500

const { set, prune, useAll, useItems, useItem } = createExternalStore<CachedNotam>({
    maxEntries: MAX_TFR_ENTRY_COUNT,
})
export const useTfrCache = useAll
export const useTfrs = useItems
export const useTFR = useItem

export const fetchAndCacheTfrs = ({ abortController }: { abortController: AbortController }) => {
    const orgId = selectActiveWorkspaceId()(store.getState())
    if (!orgId) return

    fetchApiGateway("get /org/:orgId/get-tfr", {
        params: { orgId },
        region: SupportedRegions.Canada,
        signal: abortController.signal,
    })
        .then((res) => {
            const returnedIds: string[] = []
            res.tfrs.forEach((tfr) => {
                const id = `${tfr.id}`
                returnedIds.push(id)
                const geometry = multiPolygonWithHolesToGeoJSON(tfr.geometry)
                set(id, {
                    type: "tfr",
                    feature: { type: "Feature", id, geometry, properties: tfr.properties },
                    properties: tfr.properties,
                    bbox: getMultiPolygonBounds(tfr.geometry),
                    area: tfr.properties.area,
                })
            })
            prune(returnedIds)
        })
        .catch((err) => {
            if (err?.name !== "AbortError") {
                console.warn("[tfr] fetch failed:", err)
            }
        })
}
